/**
 * @param {DayGroupShape[]} groups
 * @param {string} historyContext
 * @return {object[]}
 */
export function filterDayGroups(groups, historyContext) {
  const result = [];

  for (const group of groups) {
    if (allowGroup(group, historyContext)) {
      result.push(group);
    }
  }

  return result;
}

/**
 * @param {DayGroupShape} group
 * @param {string} historyContext
 * @return {boolean}
 */
function allowGroup(group, historyContext) {
  switch(historyContext) {
    case "submitted":
      return allowSubmitted(group);
    case "todo":
      return allowTodo(group);
    default:
      return true;
  }
}

/**
 * @param {DayGroupShape} group
 * @return {boolean}
 */
function allowSubmitted(group) {
  return group.entries.some(isSubmitted);
}

/**
 * @param {DayGroupShape} group
 * @return {boolean}
 */
function allowTodo(group) {
  return group.entries.some(isTodo, group);
}

/**
 * @param {EntryShape} entry
 * @return {boolean}
 */
function isSubmitted(entry) {
  return entry && Boolean(entry.submitted);
}

/**
 * @param {EntryShape} entry
 * @return {boolean}
 */
function isTodo(entry) {
  if (entry.entryDate.isAfter()) {
    return !entry.submitted && entry.hours > 0;
  }

  if (this.isWorkDay) {
    if (!entry.submitted) {
      return true;
    } else if (this.hoursWorked < this.workDay.workingHours) {
      return true;
    }
  }

  return false;
}



// WEBPACK FOOTER //
// ./app/utils/day-groups.js